import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { shopApi } from "./api";

const CustomerAuthContext = createContext(null);

export function CustomerAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await shopApi.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: if returning from the Google OAuth callback, skip the /me check —
    // ShopAuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const loginWithGoogle = (returnTo = "/checkout") => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    window.location.href = `${process.env.REACT_APP_BACKEND_URL}/api/auth/google/login?redirect=${encodeURIComponent(returnTo)}`;
  };

  const logout = async () => {
    try {
      await shopApi.post("/auth/logout");
    } catch {
      /* noop */
    }
    setUser(null);
  };

  return (
    <CustomerAuthContext.Provider value={{ user, loading, checkAuth, loginWithGoogle, logout, setUser }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export const useCustomerAuth = () => useContext(CustomerAuthContext);
